/*
 * @Description: 
 * @Author: yingbin
 * @Date: 2019-09-09 09:38:15
 * @LastEditTime: 2019-10-09 11:20:14
 * @LastEditors: yingbin
 */
//校验姓名
var Pswd;
var checkName = (rule, value, callback) => {
	// const nameRegA = /^(?!_)(?!.*?_$)[a-zA-Z_\u4e00-\u9fa5]{5,20}$/
	const nameRegB = /^[a-zA-Z]\w{4,15}$/
	const nameRegC = /^\d{1,}\w{4,15}$/
	const phone = /((13[0-9]|14[579]|15[0-3,5-9]|16[65]|17[0135678]|18[0-9]|19[89])\d{8})$/;
	if (!value) {
		return callback(new Error("请输入用户名"));
	}
	setTimeout(() => {
		if (phone.test(value)) {
			callback();
		} else {
			callback(new Error("请输入正确的用户手机号"));
		}
	}, 100);
};
// 校验手机号
var checkPhone = (rule, value, callback) => {
	// const phoneReg = /((13[0-9]|14[579]|15[0-3,5-9]|16[65]|17[0135678]|18[0-9]|19[89])\d{8})$/;
	const phoneReg = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|8|9])|(?:5[0-3|5-9])|(?:6[2|5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|3|5|8|9]))\d{8}$/
	if (!value) {
		return callback(new Error("手机号码不能为空"));
	}
	setTimeout(() => {
		if (phoneReg.test(value)) {
			callback();
		} else {
			callback(new Error("手机号码格式不正确"));
		}
	}, 100);
};

var checkPhoneCode = (rule, value, callback) => {
	if (!value) {
		return callback(new Error("图形验证码不能为空"));
	}
	setTimeout(() => {
		if (value.length != 4) {
			return callback(new Error("请输入正确的图形验证码"));
		} else {
			callback();
		}
	}, 100);

};
//校验邮箱
var checkEmial = (rule, value, callback) => {
	const emailReg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
	if (!value) {
		return callback(new Error("邮箱不能为空"));
	}
	setTimeout(() => {
		if (emailReg.test(value)) {
			callback();
		} else {
			callback(new Error("邮箱格式不正确"));
		}
	}, 100);
};
// 新密码
var newPswd = (rule, value, callback) => {
	Pswd = value
	var reg = /^(?=.*?[a-z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA_Z0-9]{6,16}$/;
	if (value === "") {
		callback(new Error("请输入新密码"));
	} else if (
		value.length > 16 ||
		value.length < 6
	) {
		callback(new Error("请输入6到16位密码"));
	}
	else if (!reg.test(value)) {
		callback(new Error("请输入6到16位密码，数字+字母"));
	}
	 else {
		callback();
	}
};
//老密码
var newPswd1 = (rule, value, callback) => {
	var reg = /^(?=.*?[a-z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA_Z0-9]{6,16}$/;
	console.log(reg.test(value))
	if (value === "") {
		callback(new Error("请再次输入新密码"));
	} else if (
		value.length > 16 ||
		value.length < 6
	) {
		callback(new Error("请输入6到16位密码"));
	} else if (value !== Pswd) {
		callback(new Error("两次输入密码不一致!"));
	} 
	else if (!reg.test(value)) {
		callback(new Error("请输入6到16位密码，数字+字母"));
	}
	else {
		callback();
	}
};

// 校验社会信用代码
var checkCode = (rule, value, callback) => {
	// const codeReg=/^[A-Za-z0-9]+$/
	// const codeReg =/^(?=.*?[a-z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA_Z0-9]{6,10}$/
	const codeReg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
	if (!value) {
		return callback(new Error("社会信用代码不能为空"));
	}

	setTimeout(() => {
		if (codeReg.test(value)) {
			callback();
		} else {
			callback(new Error("社会信用代码格式不正确"));
		}
	}, 100);
}

function registerRules() {
	return {
		password: [{
			required: true,
			message: "请输入密码",
			trigger: "blur"
		},
		{
			min: 6,
			max: 16,
			message: "请输入6到16位密码",
			trigger: "blur"
		}
		],
		email: [{
			validator: checkEmial,
			required: true,
			trigger: "blur"
		}],
		phone: [{
			validator: checkPhone,
			required: true,
			trigger: "blur"
		}],
		picutureCode: [{
			validator: checkPhoneCode,
			required: true,
			// message: "请输入图片验证码",
			trigger: "blur"
		},

		],
		phoneCode: [{
			required: true,
			message: "请输入手机验证码",
			trigger: "blur"
		},
		{
			min: 6,
			max: 6,
			message: "手机验证码有误",
			trigger: "blur"
		}
		]
	}
}

function loginRules() {
	return {
		name: [{
			validator: checkName,
			required: true,
			trigger: "blur"
		}],
		password: [{
			required: true,
			message: "请输入密码",
			trigger: "blur"
		},
		{
			min: 6,
			max: 16,
			message: "密码长度在6到16个字符间",
			trigger: "blur"
		}
		],
		picutureCode: [{
			required: true,
			message: "请输入图片验证码",
			trigger: "blur"
		},
		{
			min: 4,
			max: 4,
			message: "图片验证码有误",
			trigger: "blur"
		}
		],
	}
}

function getPswdRules() {
	return {
		name: [{
			validator: checkName,
			required: true,
			trigger: "blur"
		}],
		phoneCode: [{
			required: true,
			message: "请输入手机验证码",
			trigger: "blur"
		},
		{
			min: 6,
			max: 6,
			message: "手机验证码有误",
			trigger: "blur"
		}
		],
		newPswd: [{
			required: true,
			validator: newPswd,
			trigger: "blur"
		}],
		newPswd1: [{
			required: true,
			validator: newPswd1,
			trigger: "blur"
		}]
	}
}

function updatePswdRules() {
	return {
		oldPassword: [{
			required: true,
			message: "请输入原密码",
			trigger: "blur"
		},
		{
			min: 6,
			max: 16,
			message: "密码长度在6到16个字符间",
			trigger: "blur"
		}
		],
		newPassword: [{
			required: true,
			validator: newPswd,
			trigger: "blur"
		}],
		againPassword: [{
			required: true,
			validator: newPswd1,
			trigger: "blur"
		}]
	}
}

function setPswdRules() {
	return {
		newPassword1: [{
			required: true,
			// message: "请输入密码",
			validator: newPswd,
			trigger: "blur"
		},
		{
			min: 6,
			max: 16,
			message: "密码长度在6到16个字符间",
			trigger: "blur"
		}
		],
		newPassword2: [{
			required: true,
			validator: newPswd1,
			trigger: "blur"
		}],
	}
}

function phoneLoginRules() {
	return {
		phone: [{
			validator: checkPhone,
			required: true,
			trigger: "blur"
		}],
		phoneCode: [{
			required: true,
			message: "请输入手机验证码",
			trigger: "blur"
		},
		{
			min: 6,
			max: 6,
			message: "手机验证码有误",
			trigger: "blur"
		}
		]
	}
}

function companyRules() {
	return {
		cp_name: [{
			required: true,
			message: "请输入公司名称",
			trigger: "blur"
		},
		{
			min: 5,
			max: 30,
			message: "公司名长度在5到30个字符间",
			trigger: "blur"
		}
		],
		cp_city: [{
			required: true,
			message: "省市区不能为空",
			trigger: "change"
		}],
		cp_address: [{
			required: true,
			message: "详细地址不能为空",
			trigger: "blur"
		},
		{
			min: 5,
			max: 30,
			message: "详细地址长度在5到30个字符间",
			trigger: "blur"
		}
		],
		industry: [{
			required: true,
			message: "所属行业不能为空",
			trigger: "change"
		}],
		name: [{
			required: true,
			message: "请输入联系人姓名",
			trigger: "blur"
		},
		{
			min: 2,
			max: 30,
			message: "联系人姓名长度在2到30个字符间",
			trigger: "blur"
		}
		],
		phone: [{
			validator: checkPhone,
			required: true,
			trigger: "blur"
		}],
		creditCode: [{
			validator: checkCode,
			required: true,
			trigger: "blur"
		}],
		three_img: [{
			required: true,
			message: "三证合一证件不能为空",
			trigger: "change"
		}]
	}
}

function createRules() {
	return {
		name: [{
			required: true,
			pattern: /^[\s\S]*.*[^\s][\s\S]*$/,
			message: "请输入应用名称",
			trigger: "blur"
		},
		{
			min: 2,
			max: 15,
			message: "应用名称长度在2到15个字符间",
			trigger: "blur"
		}
		],
		type: [{
			required: true,
			message: "类型不能为空",
			trigger: "change"
		}],
		description: [{
			required: true,
			message: "应用描述不能为空",
			trigger: "blur"
		},
		{
			min: 2,
			max: 100,
			pattern: /^[\s\S]*.*[^\s][\s\S]*$/,
			message: "应用描述长度在2到100个字符间",
			trigger: "blur"
		}
		]
	}
}

/** 申请帮助 */
function applyHelp() {
	return {
		title:[{
			required: true,
			message: "协助主题不能为空",
			trigger: "blur"
		},{
			min:3,
			max: 50,
			message: "协助主题字符长度不能超过50",
			trigger: "blur"
		}],
		desc:[{
			required: true,
			message: "问题描述不能为空",
			trigger: "blur"
		},{
			min:5,
			max: 500,
			message: "问题描述长度不可以超过500",
			trigger: "blur"
		}],
		phone:[{
				required: true,
				message: "手机号不能为空",
				trigger: "blur"
			},{
			required: true,
			pattern:/((13[0-9]|14[579]|15[0-3,5-9]|16[65]|17[0135678]|18[0-9]|19[89])\d{8})$/,
			message: "请输入正确的手机号",
			trigger: "blur"
		}],
		email:[{
			required: true,
			message: "邮箱不能为空",
			trigger: "blur"
		},{
			pattern:/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
			message: "请输入正确的邮箱",
			trigger: "blur"
		}]
	}
}

/** 编辑应用 */
function editAudit() {
	return {
		title:[{
			required: true,
			message: "应用名称不能为空",
			trigger: "blur"
		},{
			min:3,
			max: 15,
			message: "应用名称长度3-15",
			trigger: "blur"
		}],
		desc:[{
			required: true,
			message: "应用描述不能为空",
			trigger: "blur"
		},{
			min:5,
			max: 100,
			message: "应用描述长度5-100",
			trigger: "blur"
		}],
		type:[{
			type: 'array',
			required: true,
			message: "请选择应用类型",
			trigger: "change"
		}]
	}
}

/** 变更手机号 原手机号验证 */
function changeMobileOld() {
	return {
		code:[{
			required: true,
			message: "短信验证码不能为空",
			trigger: "blur"
		},{
			min:6,
			max: 6,
			message: "短信验证码为6位",
			trigger: "blur"
		}],
	}
} 

/** 变更手机号 原手机号验证 */
function changeMobileNew() {
	return {
		phone:[{
			validator: checkPhone,
			required: true,
			trigger: "blur"
		}],
		picutureCode:[{
			required: true,
			message: "短信验证码不能为空",
			trigger: "blur"
		},{
			min:6,
			max: 6,
			message: "短信验证码为6位",
			trigger: "blur"
		}],
	}
} 

function delApis() {
	return {
		phoneCode:[{
			required: true,
			message: "短信验证码不能为空",
			trigger: "blur"
		},{
			min:6,
			max: 6,
			message: "短信验证码为6位",
			trigger: "blur"
		}],
	}
}

module.exports = {
	registerRules: registerRules(),
	loginRules: loginRules(),
	getPswdRules: getPswdRules(),
	companyRules: companyRules(),
	updatePswdRules: updatePswdRules(),
	createRules: createRules(),
	applyHelp:applyHelp(),
	editAudit:editAudit(),
	changeMobileOld:changeMobileOld(),
	changeMobileNew:changeMobileNew(),
	setPswdRules: setPswdRules(),
	phoneLoginRules: phoneLoginRules(),
	_delApis:delApis()
}